import "./PrestitoBusinessPage.css";
import { t } from "../../../services/formatters";
import { usePrestitoBusinessPage } from "./usePrestitoBusinessPage";
import { Button } from "../../../components/Button";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Riepilogo } from "../../../components/Riepilogo";
import { TextInput } from "../../../components/TextInput";
import { ErrorModal } from "../../../components/ErrorModal";
import { EditAppointmentModal } from "../../../components/EditAppointmentModal";
import { useEffect } from "react";

export const PrestitoBusinessPage = () => {
    const {
        next,
        read,
        onCfChange,
        isDatiUtenteReady,
        isCfFetchStart,
        isCfFetchError,
        getCfInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        setCodiceFiscale,
        codiceFiscale,
        codiceFiscaleError,
        askForEditAppointment,
        setPrestitoPersonale,
        setC5,
    } = usePrestitoBusinessPage();

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/prestito-business/codice-fiscale",
            funnelVersion: "nuovo",
            faFunnel: "Prestito business",
            capFiliale: read("cap"),
            presa_info: read("solo_info"),
        });
    }, []);

    return (
        <div id="business-page">
            <div className={`section page-title-component center-on-tablet`}>
                <h1>{t("prestito_business")}</h1>
                <div>{t("prestito_business_sottotitolo")}</div>
            </div>

            <div className={`section white-box input-box-component`}>
                <h2>{t("prestito_business_inserisci_cf")}</h2>
                <p className={`input-box-subtitle`}>&nbsp;</p>
                <TextInput state={getCfInputState()} name="codiceFiscale" placeholder={t("inserisci_cf")} value={read("codiceFiscale")} onChange={onCfChange} maxLength={16}></TextInput>
            </div>

            <div className="text-center text-small">
                <strong>
                    Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati
                    personali{" "}
                    <a target="_blank" href="https://www.compass.it/share/pdfsni/PRIVACY_FA.PDF">
                        <u>qui scaricabile</u>
                    </a>
                </strong>
            </div>

            <div className="section text-center">
                <Button id="go-to-select-state-btn" disabled={!isDatiUtenteReady()} onClick={next} classList="btn-responsive always-style" loading={isCfFetchStart()} text={`${t("avanti")}`} />
            </div>

            <div className="external-products-footer-component">
                <p id="or-text" className="text-center">
                    {t("oppure")}
                </p>

                <div className="section flex-row centered-content text-center">
                    <h4 className="flex-cell clickable">
                        <a
                            onClick={setC5}
                            className="hide-tablet hide-desktop"
                            aria-roledescription="link"
                            aria-label={t("cessione_quinto")}
                            dangerouslySetInnerHTML={{ __html: t("cessione_quinto") }}></a>
                        <a onClick={setC5} className="hide-mobile" aria-roledescription="link" aria-label={t("cessione_quinto")} dangerouslySetInnerHTML={{ __html: t("cessione_quinto_tablet") }}></a>
                    </h4>
                    <h4 className="flex-cell clickable">
                        <a
                            onClick={() => {
                                window.location.host.indexOf("compassquinto") != -1 ? (window.location.href = "https://www.compass.it/fa3/") : setPrestitoPersonale();
                            }}
                            className="hide-tablet hide-desktop"
                            aria-roledescription="link"
                            aria-label={t("finanziamento_standard")}
                            dangerouslySetInnerHTML={{ __html: t("finanziamento_standard") }}></a>
                        <a
                            onClick={() => {
                                window.location.host.indexOf("compassquinto") != -1 ? (window.location.href = "https://www.compass.it/fa3/") : setPrestitoPersonale();

                                console.log("nuova");
                            }}
                            className="hide-mobile"
                            aria-roledescription="link"
                            aria-label={t("finanziamento_standard")}
                            dangerouslySetInnerHTML={{
                                __html: t("finanziamento_standard"),
                            }}></a>
                    </h4>
                </div>

                {/* Edit appto link */}
                <div className="section text-center bottom-area">
                    <div className={`section edit-appointment-link-component text-uppercase color-text-primary clickable`} onClick={askForEditAppointment}>
                        {t("modifica_appuntamento_gia_fissato")}
                    </div>
                </div>
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>

            <EditAppointmentModal open={showModal} title={t("modifica_appuntamento")} text={t("modifica_appuntamento_esistente_unknown_nocf")} onCloseModal={closeModal}></EditAppointmentModal>
        </div>
    );
};
